<template>
  <div class="navT">
    <div>
      <h4>{{titleS}}</h4>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavT',
    props:['titleS'],
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.navT{
  border-bottom: 1px solid #c9c9c9;
  overflow: hidden;
  margin-bottom: 25px;
  h4{
    height: 50px;
    font-size: 18px;
    margin-top: 16px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/personalPage/NavT.vue